import { Injectable } from '@angular/core';

import { ExpiringCache } from './expiring-cache';

@Injectable({ providedIn: 'root' })
export class ExpiringCacheFactory {
    create(cacheTime: number): ExpiringCache {
        return new ExpiringCache(cacheTime);
    }
}
